import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="76"
      height="77"
      viewBox="0 0 76 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.6021 76.3V66.85C59.2295 66.85 66.2484 59.7847 66.2484 51.1H75.6362C75.6362 64.9953 64.4059 76.3 50.6021 76.3ZM50.6021 0.700012V10.15C59.2295 10.15 66.2484 17.2154 66.2484 25.9H75.6362C75.6362 12.0047 64.4059 0.700012 50.6021 0.700012ZM25.5681 66.85H9.92181V51.1H0.534042V76.3H25.5681V66.85ZM9.92181 10.15H25.5681V0.700012H0.534042V25.9H9.92181V10.15Z"
        fill="white"
      />
    </svg>
  );
};

export default LogoIcon;
